import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import MDButton from 'components/MDButton';

function AaroCustomerName({ id, formattedValue }) {
    // Extract customer ID from AAro
    const customerID = id ? id.split('-')[0] : '';

    return (
        <MDButton
            variant="text"
            color="dark"
            component={Link}
            to={`../customers/${customerID}`}
            target="_blank"
            rel="noopener noreferrer"
        >
            {formattedValue}
        </MDButton>
    );
}

export default memo(AaroCustomerName);
